import { BaseAPIError } from './BaseAPIError'

export class ServerAPIError extends BaseAPIError {}
